import React, { useEffect, useState } from "react";

import "./CSS/ListingsHome.css";

import { SearchParams } from "../../atomic_components/types";
import { AppDispatch } from "../../state";
import { useDispatch } from "react-redux";
import { ActiveTab__Action } from "../../state/action-creators";
import { useAppSelector } from "../../state/hooks";
import { useHistory, useParams } from "react-router-dom";
import ListingsAll from "./ListingsAll";
import ListingsTop from "./ListingsTop";
import ListingsBulkOperations from "./ListingsBulkOperations";

interface RouteParams {
  category: string; // Define the type for the parameter you're expecting
}

function ListingsHome() {
  const dispatch: AppDispatch = useDispatch();
  const history = useHistory();
  useEffect(() => {
    dispatch(ActiveTab__Action("listings"));
  }, []);

  const { category } = useParams<RouteParams>();
  const [selectedItem, setSelectedItem] = useState(category);
  const handleItemClick = (item: string) => {
    setSelectedItem(item);
    history.push(`/listings/${item}`);
  };

  useEffect(() => {
    setSelectedItem(category);
  }, [category]);

  return (
    <div>
      <div className="nav-container">
        <nav className="navbar-listings">
          <ul className="navbar-menu">
            <li
              className={`navbar-item ${
                selectedItem === "all" ? "active" : ""
              }`}
              onClick={() => handleItemClick("all")}
            >
              All Listings
            </li>
            <li
              className={`navbar-item ${
                selectedItem === "top" ? "active" : ""
              }`}
              onClick={() => handleItemClick("top")}
            >
              Top 500
            </li>
            <li
              className={`navbar-item ${
                selectedItem === "bulk" ? "active" : ""
              }`}
              onClick={() => handleItemClick("bulk")}
            >
              Bulk Operations
            </li>
          </ul>
        </nav>
      </div>

      {selectedItem == "all" && <ListingsAll />}
      {selectedItem == "top" && <ListingsTop />}
      {selectedItem == "bulk" && <ListingsBulkOperations />}
    </div>
  );
}

export default ListingsHome;
